"use client";

import { cn } from "@/lib/utils";

export function railButtonClass(
  collapsed: boolean,
  isMobile: boolean,
  { quiet = true }: { quiet?: boolean } = {},
) {
  return cn(
    "group relative flex w-full items-center rounded-md transition-all duration-150 min-w-0",
    "focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-primary/40",
    quiet && "hover:bg-white/[0.04] active:bg-white/[0.06]",
    quiet && (isMobile ? "text-zinc-300" : "text-foreground/70 hover:text-foreground"),
    !isMobile && (collapsed ? "flex-col justify-center gap-1 px-1 py-2" : "gap-2.5 px-2.5 py-2"),
    isMobile && "gap-3 px-2.5 min-h-11",
  );
}

export function RailLabel({
  label,
  collapsed,
  isMobile,
}: {
  label: string;
  collapsed: boolean;
  isMobile: boolean;
}) {
  if (!isMobile && collapsed) {
    return <span className="text-[10px] font-medium leading-none">{label}</span>;
  }
  return (
    <span className={cn("truncate font-medium", isMobile ? "text-[14px]" : "text-[15px] md:text-[13px]")}>
      {label}
    </span>
  );
}
